<template>
  <v-dialog class="dialog" :value="value" width="600" @input="emitInput">
    <div class="video-preview-wrapper" :key="videoId">
      <div class="close" @click="closeModal">&times;</div>
      <iframe
        :src="videoSrc"
        style="border: none"
        height="400"
        width="600"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowfullscreen="true"
      ></iframe>
    </div>
  </v-dialog>
</template>

<script>
export default {
  components: {},

  data() {
    return {};
  },

  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    videoId: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    videoSrc() {
      return (
        this.videoUrl.replace("watch", "iframe") +
        "?autoplay=true&controls=false"
      );
    },
  },

  watch: {},

  methods: {
    closeModal() {
      this.emitInput(false);
    },
    emitInput(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style lang="scss" scoped>
.video-preview-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;

  .close {
    background: white;
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 5px;
    right: 5px;
    height: 30px;
    width: 30px;
    font-size: 28px;
    box-shadow: 0 3px 6px rgba(#000000, 0.16);
    z-index: 1;
    border-radius: 50%;
  }
}
</style>
